import { useSelector, useStore } from "react-redux";
import { useState, useEffect } from "react";
import func from "@uikit/func";

export default function useEditorPermission() {
  const store = useStore();

  const [enableBrainStudios, setEnableBrainStudios] = useState(true);

  const meLoading = useSelector(state => state.editor.meLoading);

  useEffect(() => {
    if (meLoading) {
      // 这里重置状态确保在/denied-tip页面手动切换url时，重新获取me后能正确再次跳转到denied-tip页面
      setEnableBrainStudios(true);
      return;
    }
    const userPermission = store.getState().editor.me.profile?.permissions;
    if (func.isEmpty(userPermission)) {
      setEnableBrainStudios(false);
      return;
    }
    const component = userPermission.find(x => x.key === "components") || {};
    if (!func.isEmpty(component.value)) {
      const componentList = component.value;
      setEnableBrainStudios(componentList.includes("brain_studios"));
    } else {
      setEnableBrainStudios(false);
    }
  }, [meLoading]);

  return {
    enableBrainStudios,
  };
}
